module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.073dba1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/amwayterms/css/fonts/notosanskr/notokr-bold.woff2
// module id = 1dsI
// module chunks = 0